module.exports = __webpack_public_path__ + "static/img/logo1.9e69843.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/logo1.png
// module id = u4/N
// module chunks = 0